import { Dialog } from "@headlessui/react";
import { IKImage } from "imagekitio-react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { SET_USER_PRICING_CARD_ID } from "../../redux/actions/types";

export default function DiscountModal({
  openDiscountModal,
  modalData,
  setDiscountModal,
  modalType,
}) {
  const name = useSelector((store) => store?.profileDetails?.name);
  const date = moment(
    modalData?.expires_at ? modalData?.expires_at : Date.now() + 86400000,
  ).format("Do MMMM YYYY");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <div>
      <Dialog
        open={openDiscountModal}
        onClose={() =>
          setDiscountModal((prev) => ({ ...prev, open: false, data: null }))
        }
        as="div"
        style={{ zIndex: "9999999999" }}
        className="fixed inset-0 z-10 flex flex-col items-center justify-center overflow-y-auto md:mt-20 md:justify-start"
      >
        <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
        <Dialog.Title />
        <Dialog.Description />
        <div className="z-10 flex h-[32rem] w-5/6 flex-col items-center justify-between rounded-2xl bg-white py-4 px-4 text-center shadow-2xl md:h-[30rem] md:w-2/3 md:p-4 lg:w-[30rem]">
          <img
            urlEndpoint="https://img.learntube.ai/public-assets/"
            src="https://img.learntube.ai/public-assets/PRICING/Happy_friends_drinking_wine_or_beer_together__Converted_.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1662028563407"
            className="h-32 w-full md:h-36 md:w-full"
            transformation={[
              {
                height: "160",
                width: "160",
              },
            ]}
          />
          <div className="flex h-full w-full flex-col items-center justify-between p-2 py-4">
            <h1 className="text-2xl font-bold">
              Congrats! {modalData?.discount ? modalData?.discount : "55"}%
              discount Unlocked
            </h1>
            <p className="text-sm md:text-base">
              {name}, you’ve unlocked upto{" "}
              {modalData?.discount ? modalData?.discount : "55"}% off on
              LearnTube Pro plans for {modalType?.message}. Discount valid till:{" "}
              {date}
            </p>
          </div>
          <div className="flex h-full w-full flex-col items-center justify-start p-2 py-4">
            <button
              style={{
                background:
                  "linear-gradient(238.65deg, #13A0BD 20%, #086788 89.97%)",
              }}
              className="mb-5 w-full rounded-3xl px-6 py-2 text-xs text-white md:w-[70%] md:text-sm"
              onClick={(event) => {
                dispatch({ type: SET_USER_PRICING_CARD_ID, payload: 1 });
                navigate("/pricing");
              }}
            >
              <span className="font-semibold">
                Get 100% Placement Support Plan
              </span>
              <br />
              <span className="text-xs">starts Rs. 89/month</span>
            </button>
            <button
              className="w-full rounded-3xl border-2 border-[#086788] px-5 py-1 text-xs font-bold text-[#086788] md:w-[70%] md:text-sm"
              onClick={(event) => {
                dispatch({ type: SET_USER_PRICING_CARD_ID, payload: 3 });
                navigate("/pricing");
              }}
            >
              <span className="font-semibold">
                Get Unlimited Certification Plan
              </span>
              <br />
              <span className="text-xs">starts Rs. 167/month</span>
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
